import React from "react";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";

import { makeStyles } from "@material-ui/core/styles";

import { m } from "../utils/i18n";

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    "& > * + *": {
      marginBottom: theme.spacing(2),
    },
  },
}));

// export const MessageSnackbar = ({ formData, steps, setShowSummary }) => {
export const MessageSnackbar = ({
  messageSnackbarOpen,
  setMessageSnackbarOpen,
  messageSnackbarText,
  setMessageSnackbarText,
}) => {
  const classes = useStyles();

  // const [open, setOpen] = React.useState(false);

  // const handleClick = () => {
  //   setOpen(true);
  // };

  const handleClose = (event, reason) => {
    /*
    if (reason === 'clickaway') {
      return;
    }
*/
    setMessageSnackbarOpen(false);
    setMessageSnackbarText("");

  };

  const alertMessage = (messageSnackbarText === "") ? m("common.error.step_incompleted") : messageSnackbarText;
  return (
    <div className={classes.root}>
      {/* <Button variant="outlined" onClick={handleClick}>
        Open success snackbar
      </Button> */}
      <Snackbar
        open={messageSnackbarOpen}
        autoHideDuration={3000}
        onClose={handleClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert onClose={handleClose} severity="error">
          {alertMessage}
        </Alert>
      </Snackbar>
    </div>
  );
};
